const WHITELISTED_LOG_KEYS=["canonicalId","shopperId","orderNumber","orderId","order","tenantId","locale","isLegacy","origin","state","productId","productKey","id","itemId","creditable","replaceable","refundable","lineItems","cancellable","orderData","shippingAddress","billingAddress"];const SENSITIVE_LOG_KEYS_TO_REDACT=["email","phone"];

export { SENSITIVE_LOG_KEYS_TO_REDACT, WHITELISTED_LOG_KEYS };
//# sourceMappingURL=logging.js.map
